import styled, { WithTheme } from '@emotion/styled';
import { css, keyframes } from '@emotion/core';
import { StyledProps as Props, Theme } from './AnimatedLogo.types';

// This is the path that both the ball and the line will take.
// eslint-disable-next-line max-len
export const animationPath =
  'M-30.5508 140.928C30.5507 79.8262 117.768 8.37686 121.217 126.638C140.435 48.7827 190.696 22.174 216.812 5.91309';
const aniTime = '2s';

const Move = keyframes`
  0% {
    offset-distance: 0%;
    stroke-dashoffset:382;
  }
  20% {
    offset-distance: 100%;
    stroke-dashoffset: 0;
  }
  
  100%{
    offset-distance: 100%;
    stroke-dashoffset: 0;
  }
`;

export const Squiggle = styled.path`
  stroke-dasharray: 382;
  stroke-dashoffset: 382;
  animation: ${Move} ${aniTime} ease-out infinite;
`;

export const Ball = styled.circle`
  offset-path: path('${animationPath}');
  animation: ${Move} ${aniTime} ease-out infinite;
`;

export const Item = styled.div<Props, Theme>`
  ${(p: WithTheme<Props, Theme>) =>
    css({
      width: p.size ? `${p.size}px` : '250px',
      height: p.size ? `${p.size}px` : '250px',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
    })}
`;

export const InnerContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Container = styled.div<Props, Theme>`
  ${(p: WithTheme<Props, Theme>) =>
    css({
      zIndex: 2,
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: p.fullPageBackgroundColour || 'var(--color-extra-white)',
    })}
`;
